'use client';

import { Suspense } from 'react';

import { ErrorBoundary } from '@packages/shared/src/ui/ErrorBoundary/ErrorBoundary';

import { useServiceLink } from '../../shared/useServiceLink';
import type { SlotProps } from '../Base/Slot.client';
import { Slot } from '../Base/Slot.client';
import { ServiceSlotMenuList } from '../Base/ServiceSlotMenuList';

/** Service slot with list of helpers in popover */
export const ServiceSlot = (props: Pick<SlotProps, 'priority'>) => {
  const { href, label } = useServiceLink();

  return (
    <div className="hidden lg:block">
      <Slot
        {...props}
        icon={<span className="icon-emp-service size-4" />}
        title={label}
        href={href}
      >
        <ErrorBoundary>
          <Suspense>
            <ServiceSlotMenuList />
          </Suspense>
        </ErrorBoundary>
      </Slot>
    </div>
  );
};
